var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIngresosEstables(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.843,
    height: 55.376,
    viewBox: "0 0 66.843 55.376",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ico_mobile_ingresos_lineal_color",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18081",
    "data-name": "Grupo 18081",
    transform: "translate(-0.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18080",
    "data-name": "Grupo 18080",
    transform: "translate(39.687 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_1719",
    "data-name": "Elipse 1719",
    cx: 12.226,
    cy: 12.17,
    rx: 12.226,
    ry: 12.17,
    fill: "#1aa8a2",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18079",
    "data-name": "Grupo 18079",
    transform: "translate(9.302 6.334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107321",
    "data-name": "Trazado 107321",
    d: "M384.6,110.4a3.076,3.076,0,0,0-3.45-.754,2.049,2.049,0,0,0-.22,3.834c.313.147,1.116.461,2.327.887,2.711.954,2.8,4.5-.417,4.777a4.1,4.1,0,0,1-3.414-1.2",
    transform: "translate(-379.424 -108.414)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_8999",
    "data-name": "L\\xEDnea 8999",
    y2: 0.826,
    transform: "translate(2.791 10.846)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_9000",
    "data-name": "L\\xEDnea 9000",
    y2: 0.982,
    transform: "translate(2.791)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18108",
    "data-name": "Grupo 18108",
    transform: "translate(6341.072 17841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107332",
    "data-name": "Trazado 107332",
    d: "M-6316-17828.926v4.836h-24.011v-5.086h24.513",
    fill: "#fce3ed",
    stroke: "#3b0310",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "maletin",
    transform: "translate(-6340 -17841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107330",
    "data-name": "Trazado 107330",
    d: "M19,4H17.9A5.009,5.009,0,0,0,13,0H11A5.009,5.009,0,0,0,6.1,4H5A5.006,5.006,0,0,0,0,9v3H24V9a5.006,5.006,0,0,0-5-5ZM8.184,4A3,3,0,0,1,11,2h2a3,3,0,0,1,2.816,2Z",
    fill: "#ee2b7c",
    stroke: "#3b0310",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107331",
    "data-name": "Trazado 107331",
    d: "M13,15a1,1,0,0,1-2,0V14H0v5a5.006,5.006,0,0,0,5,5H19a5.006,5.006,0,0,0,5-5V14H13Z",
    fill: "#ee2b7c",
    stroke: "#3b0310",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18083",
    "data-name": "Grupo 18083",
    transform: "translate(0 30.188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107322",
    "data-name": "Trazado 107322",
    d: "M201.53,300.72l3.917-18.158h6.523l3.917,18.158",
    transform: "translate(-176.287 -282.562)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107323",
    "data-name": "Trazado 107323",
    d: "M169.489,411.7H138.523v-3.1a4,4,0,0,1,4-4h22.966a4,4,0,0,1,4,4Z",
    transform: "translate(-121.584 -388.513)",
    fill: "#ee2b7c",
    stroke: "#3b0310",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_9001",
    "data-name": "L\\xEDnea 9001",
    x2: 64.843,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18082",
    "data-name": "Grupo 18082",
    transform: "translate(4.298 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107324",
    "data-name": "Trazado 107324",
    d: "M54.7,289.627H47.294a4.686,4.686,0,0,1-4.686-4.686v-2.379h16.78v2.379A4.686,4.686,0,0,1,54.7,289.627Z",
    transform: "translate(-42.608 -282.562)",
    fill: "#fce3ed",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107325",
    "data-name": "Trazado 107325",
    d: "M354.166,289.627h-7.408a4.686,4.686,0,0,1-4.686-4.686v-2.379h16.78v2.379A4.686,4.686,0,0,1,354.166,289.627Z",
    transform: "translate(-302.604 -282.562)",
    fill: "#fce3ed",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_9002",
    "data-name": "L\\xEDnea 9002",
    x2: 36.033,
    transform: "translate(14.405 23.187)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIngresosEstables);
export default __webpack_public_path__ + "static/media/ingresos-estables.d4863a24faa3536cbf715af153a6e65d.svg";
export { ForwardRef as ReactComponent };